import { render, staticRenderFns } from "./Frontend.vue?vue&type=template&id=12a6e604&scoped=true&"
import script from "./Frontend.vue?vue&type=script&lang=js&"
export * from "./Frontend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a6e604",
  null
  
)

export default component.exports